import {createI18nScope, ref} from 'common/i18n/scope';
import globalSidenavScope from 'iron/routes/global-sidenav/index.i18n';

export default createI18nScope(`common.report.util.search`, {
  'mixology.app.agent-flows': ref(globalSidenavScope, `mixology.app.agent-flows`),
  'mixology.app.boards': ref(globalSidenavScope, `mixology.app.boards`),
  'mixology.app.experiments': ref(globalSidenavScope, `mixology.app.experiments`),
  'mixology.app.feature-flags': ref(globalSidenavScope, `mixology.app.feature-flags`),
  'mixology.app.flows': ref(globalSidenavScope, `mixology.app.flows`),
  'mixology.app.funnels': ref(globalSidenavScope, `mixology.app.funnels`),
  'mixology.app.heat-map-collections': ref(globalSidenavScope, `mixology.app.heat-map-collections`),
  'mixology.app.heat-maps': ref(globalSidenavScope, `mixology.app.heat-maps`),
  'mixology.app.impact': ref(globalSidenavScope, `mixology.app.impact`),
  'mixology.app.insights': ref(globalSidenavScope, `mixology.app.insights`),
  'mixology.app.metric-trees': ref(globalSidenavScope, `mixology.app.metric-trees`),
  'mixology.app.playlists': ref(globalSidenavScope, `mixology.app.playlists`),
  'mixology.app.retention': ref(globalSidenavScope, `mixology.app.retention`),
  'search.allow-storage-prompt': `Personalize your Mixpanel experience in your user settings`,
  'search.boards-and-reports': `Boards & Reports`,
  'search.most-viewed': `Most Viewed`,
  'search.recently-viewed': `Recently Viewed`,
  'search.sort-options.most-viewed': `Most Viewed`,
  'search.sort-options.recently-modified': `Recently Modified`,
  'search.sort-options.recently-viewed': `Recently Viewed`,
  'search.sort-options.relevance': `Relevance`,
  'search.sort-options.title-asc': `Title A-Z`,
  'search.sort-options.title-desc': `Title Z-A`,
});
